/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";

function ATMReplenishmentsGrid({ requests }: { requests: any[] }) {
  const nf = Intl.NumberFormat();

  const services: any[] = [];
  const denominations: any[] = [];

  let notesGrandTotal = 0;
  let amountGrandTotal = 0;

  const notesTotals: any[] = [];

  requests.forEach((req) => {
    req.denominations.forEach((dn: any) => {
      const denom = denominations.find(
        (dnm) => dnm.denomination === dn.denomination
      );

      if (!denom) {
        denominations.push({ denomination: dn.denomination });
      }
    });

    const replNotes: any = {};

    req.denominations.forEach((dn: any) => {
      replNotes[dn.denomination] = dn.notes;
    });

    notesGrandTotal += req.totalNotes;
    amountGrandTotal += req.totalAmount;

    const obj = {
      serialNo: req.serialNo,
      locationId: req.locationId,
      locationName: req.locationName,
      totalNotes: req.totalNotes,
      totalAmount: req.totalAmount,
      remarks: req.remarks,
      replNotes,
    };

    services.push(obj);

    notesTotals.push(replNotes);
  });

  return (
    <div className="w-full">
      <table width="100%">
        <thead>
          <tr>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Sr. #
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              ATM ID
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Location
            </th>
            <th
              colSpan={denominations.length}
              style={{
                textAlign: "center",
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
              }}
            >
              Denominations
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Bank Notes
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Total Amount (AED)
            </th>
            <th
              rowSpan={2}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.6rem",
                textAlign: "left",
                paddingLeft: "2px",
              }}
            >
              Remarks
            </th>
          </tr>
          <tr>
            {denominations.map((dnm, i) => {
              return (
                <th
                  key={`repl${i}`}
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {dnm.denomination}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {services.map((req, i) => {
            return (
              <tr key={`row${i}`}>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                    width: "80px",
                  }}
                >
                  {req.serialNo}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.locationId}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.locationName}
                </td>

                {denominations.map((dnm, ind) => {
                  const denom = dnm.denomination;
                  return (
                    <td
                      key={`rn${ind}`}
                      style={{
                        textAlign: "center",
                        border: "0.02rem solid grey",
                        fontSize: "0.6rem",
                      }}
                    >
                      {req.replNotes[denom]
                        ? nf.format(req.replNotes[denom])
                        : 0}
                    </td>
                  );
                })}

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                    paddingLeft: "2px",
                  }}
                >
                  {req.totalNotes ? nf.format(req.totalNotes) : 0}
                </td>

                <td
                  style={{
                    textAlign: "center",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {req.totalAmount ? nf.format(req.totalAmount) : 0}
                </td>
                <td
                  style={{
                    textAlign: "left",
                    border: "0.02rem solid grey",
                    fontSize: "0.6rem",
                  }}
                >
                  {req.remarks}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td
              colSpan={3}
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              Total
            </td>

            {denominations.length > 0 &&
              denominations.map((dnm, i) => {
                const denom = dnm.denomination;
                let total = 0;

                notesTotals.forEach((ct) => {
                  total += ct[denom] ? ct[denom] : 0;
                });
                return (
                  <td
                    key={i}
                    style={{
                      border: "0.02rem solid grey",
                      fontSize: "0.7rem",
                      fontWeight: "bold",
                      textAlign: "center",
                      paddingLeft: "2px",
                    }}
                  >
                    {nf.format(total)}
                  </td>
                );
              })}

            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(notesGrandTotal)}
            </td>
            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            >
              {nf.format(amountGrandTotal)}
            </td>
            <td
              style={{
                border: "0.02rem solid grey",
                fontSize: "0.7rem",
                fontWeight: "bold",
                textAlign: "center",
                paddingLeft: "2px",
              }}
            />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export default React.memo(ATMReplenishmentsGrid);
